<template>
  <div>
    <v-dialog title="Edit Quick Push" :visible.sync="dialogVisible" width="65vw" @open="onOpen" @closed="onClosed">
      <el-form class="padding-lr" ref="form" :model="form" :rules="formRules" label-width="140px">
        <el-form-item label="" prop="">
            <p class="right-find">
            <i class="el-icon-warning-outline"></i>请务必确保礼来有使用以下内容的版权，如需查询，烦请使用VPN登录此网站：
            <a href="https://www.rightfind.com" target="_blank">https://www.rightfind.com</a>
          </p>
        </el-form-item>
        <el-form-item label="Greetings" prop="greeting">
          <el-input class="greet-input" placeholder="Please input greetings" v-model="form.greeting" maxlength="100" />
        </el-form-item>
        <el-form-item ref="pushToMSL" label="Push to Me" prop="pushToMSL">
          <div>
            <el-checkbox v-model="form.pushToMSL" :disabled="disablePushToMSL">Push to Me</el-checkbox>
            <el-button v-if="disablePushToMSL" class="bind-wechat-link" type="text" @click="bindWeChat()">
              Bind WeChat?
            </el-button>
          </div>
          <div class="push-to-msl-msg" slot="error">{{ pushToMSLMsg }}</div>
        </el-form-item>
        <el-form-item :label="formItemLabel" prop="seIds">
          <el-radio-group v-model="seType" @input="changeSeType" v-if="isSupervisor|| isMSL">
                <el-radio label="All">All</el-radio>
                <el-radio label="SE">SE</el-radio>
                <el-radio label="CE">CE</el-radio>
              </el-radio-group>
          <SEMultipleSelect v-model="form.seIds" :showTips="true" :placeholder="selectPlaceholder" :options="seListByType"
            @select-change="onSESelectChange" type="quickPush" />
        </el-form-item>
        <el-form-item label="Title" prop="title">
          <el-input placeholder="Please input title" v-model="form.title" maxlength="100" />
        </el-form-item>
        <el-form-item label="Business Purpose" prop="businessPurposeId">
          <el-select v-model="form.businessPurposeId" placeholder="Please select business purpose">
            <el-option v-for="(item, index) in businessPurposeList" :label="item.Name" :value="item.Id" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="Security Level" prop="levelId">
          <el-select v-model="form.levelId" placeholder="Please select security level">
            <el-option v-for="(item, index) in securityLevelsList" :label="item.Name" :value="item.Id" :key="index" />
          </el-select>
          <p class="security-level">
            <i class="el-icon-warning-outline"></i>本平台禁止传输Orange/Red
            CCI文件
          </p>
        </el-form-item>
        <el-form-item label="Request" prop="inquiry">
          <el-input placeholder="Please input request" v-model="form.inquiry" maxlength="100" />
        </el-form-item>
        <el-form-item label="VV Number" prop="vvNumber">
          <el-input placeholder="Please input vv number" v-model="form.vvNumber" maxlength="40" />
        </el-form-item>
        <el-form-item label="Upload file">
          <MultipleFileUpload ref="fileUpload" action="/quickPush/uploadFile" accept=".PDF,.pdf,.docx,doc,.ppt,.pptx"
            message="Only PDF, Doc and PPT file can be uploaded" @success="onFileUpload" />
          <ul class="upload-files">
            <li class="upload-file-item" v-for="(file, i) in files" :key="i">
              <a :href="file.previewUrl" target="_blank" :title="file.originalName">
                <i class="el-icon-document"></i>
                {{ file.originalName }}
              </a>
              <span @click="deleteFile(i)">
                <i class="el-icon-close"></i>
              </span>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="Content" class="editor" prop="paperContent">
          <TinymceEditor v-if="visible" :height="200" v-model="form.paperContent" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="footer">
        <el-button type="primary" @click="onPreview" :loading="previewing">
          {{ previewLabel }}
        </el-button>
        <el-button type="primary" @click="onSubmit(1)" :disabled="actionDisabled">
          Submit
        </el-button>
        <el-button @click="onSubmit(0)" :disabled="actionDisabled">
          Save Draft
        </el-button>
      </div>
    </v-dialog>
    <QRCodeDialog :visible.sync="qrcodeDialogVisible" :data.sync="previewUrl" />
  </div>
</template>

<script>
import TinymceEditor from "../../components/tinymce-editor";
import { trimValidate } from "../../utils/validator";
import MultipleFileUpload from "../../components/multiple-file-upload";
import QRCodeDialog from "./qrcode-dialog";
import { filesHandler } from "../../utils";
import { RoleCode } from "@/utils/role-constant";
import SEMultipleSelect from "../../components/se-multiple-select";

export default {
  name: "edit-quick-push-dialog",
  components: {
    SEMultipleSelect,
    MultipleFileUpload,
    TinymceEditor,
    QRCodeDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    const validatePushToMSL = (rule, value, callback) => {
      if (
        this.isSelectSEUncertified &&
        !this.pushToMSL &&
        !value
      ) {
        return callback(new Error());
      }
      callback();
    };
    return {
      seType: 'All',
      dialogVisible: this.visible,
      actionDisabled: false,
      form: {
        greeting: "",
        pushToMSL: false,
        seIds: [],
        title: "",
        businessPurposeId: "",
        levelId: "",
        inquiry: "",
        vvNumber: "",
        paperContent: "",
      },
      uploadFiles: [],
      formRules: {
        greeting: [
          {
            required: true,
            validator: trimValidate("Please input greetings"),
            message: "Please input greetings",
            trigger: "blur",
          },
        ],
        pushToMSL: {
          type: "boolean",
          required: false,
          trigger: "change",
          validator: validatePushToMSL,
        },
        seIds: {
          required: true,
          message: "Please select HCP",
          trigger: "change",
        },
        title: [
          {
            required: true,
            validator: trimValidate("Please input title"),
            trigger: "blur",
          },
        ],
        businessPurposeId: [
          {
            required: true,
            message: "Please select business purpose",
            trigger: "change",
          },
        ],
        levelId: [
          {
            required: true,
            message: "Please select security level",
            trigger: "change",
          },
        ],
        inquiry: [
          {
            required: true,
            validator: trimValidate("Please input inquiry"),
            trigger: "blur",
          },
        ],
        paperContent: [
          {
            required: true,
            message: "Please input content",
            trigger: "blur",
          },
        ],
      },
      seList: [],
      businessPurposeList: [],
      securityLevelsList: [],
      isSelectSEUncertified: false,
      previewing: false,
      qrcodeDialogVisible: false,
      previewUrl: null,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    userInfo() {
      return this.$store.state.userInfo || {};
    },
    disablePushToMSL() {
      return this.userInfo.bindStatus !== 2;
    },
    pushToMSLMsg() {
      return this.disablePushToMSL
        ? `Please bind WeChat first then check 'Push to Me' option`
        : this.form.pushToMSL
          ? ""
          : `Please check 'Push to Me' option`;
    },
    previewLabel() {
      return this.previewing ? "Previewing" : "Preview";
    },
    files() {
      return filesHandler(this.uploadFiles);
    },

    nameLabel() {
      const role = this.$store.state.role;
      return role === RoleCode.ML || role === RoleCode.Supervisor
        ? "HCP"
        :(role === RoleCode.VMSL?'vCE':"Customer");
    },
    formItemLabel() {
      return `Select ${this.nameLabel}`;
    },
    selectPlaceholder() {
      return `Please select ${this.nameLabel.toLowerCase()}`;
    },
    isBatchPush() {
      if (this.form.seIds.length === 1) {
        return false;
      }
      return this.form.seIds.length > 1 || this.data.BatchID;
    },
    seIds() {
      if (this.isBatchPush) {
        return `'${this.form.seIds.toString().replace(",", "','")}'`;
      }
      return this.form.seIds[0];
    },
    isSupervisor() {
      return this.$store.state.role === RoleCode.Supervisor
    },
    isMSL() {
      return this.$store.state.role === RoleCode.ML;
    },
    seListByType(){
      if(this.seType=='All') return this.seList
      return this.seList.filter(item=>item.types?item.types.includes(this.seType):'')
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
    dialogVisible(value) {
      this.$emit("update:visible", value);
    },
  },
  created() {
    this.formRules.seIds.message = this.selectPlaceholder;
  },
  methods: {
    changeSeType(){
      this.form.seIds = []
    },
    onClosed() {
      this.$refs.form.resetFields();
      this.$set(this.formRules.pushToMSL, "required", false);
      this.isSelectSEUncertified = false;
      this.actionDisabled = false;
      this.previewing = false;
      this.uploadFiles = [];
      this.$emit("update:data", null);
    },
    onOpen() {
      this.getAllData();
    },
    getAllData() {
      this.seType='All'
      this.checkBindWeChatStatus();
      let viewContentUrl = "/quickPush/viewContent";
      let params = { pushContentId: this.data.MessageHeadID };
      // batch push
      if (this.data.OneTimeRequest === 4) {
        viewContentUrl = "/quickPush/viewBatchContent";
        params = { batchId: this.data.BatchID };
      }
      this.$axios
        .all([
          this.axios.get("/quickPush/seList"),
          this.axios.get("/quickPush/businessPurpose"),
          this.axios.get("/quickPush/securityLevel"),
          this.axios.get(viewContentUrl, { params }),
        ])
        .then((res) => {
          this.handleSEListResp(res[0]);
          this.handleBusinessPurposeListResp(res[1]);
          this.handleSecurityLevelListResp(res[2]);
          this.handleQuickPushContentResp(res[3]);
        });
    },
    handleSEListResp({ code, data }) {
      if (200 === code) {
        this.$set(this, "seList", data);
      }
    },
    handleBusinessPurposeListResp({ code, data }) {
      if (200 === code) {
        this.$set(this, "businessPurposeList", data);
      }
    },
    handleSecurityLevelListResp({ code, data }) {
      if (200 === code) {
        this.$set(this, "securityLevelsList", data);
      }
    },
    handleQuickPushContentResp({ code, data }) {
      if (200 === code) {
        this.uploadFiles = data.files || [];
        const contentData = Object.assign({}, data);
        delete contentData.files;
        if (data.seId) {
          data.seIds = [data.seId];
        }
        Object.assign(this.form, data);
        if (this.selectedSEValidate()) {
          this.$message.error(
            "Selected HCP is currently invalid or has been transferred, please cancel your selected."
          );
          return;
        }
      }
    },
    checkBindWeChatStatus() {
      this.axios
        .get("/user/bind", {
          headers: {
            showLoading: false,
          },
        })
        .then(({ code, data }) => {
          if (code === 200 && data) {
            const bindStatus = data.bindStatus;
            this.$store.commit("updateState", {
              userInfo: {
                ...this.userInfo,
                bindStatus,
              },
            });
          }
        });
    },
    bindWeChat() {
      this.bus.$emit("bindWeChat");
    },
    onSESelectChange({ isUncertified }) {
      this.isSelectSEUncertified = isUncertified;
      this.$set(
        this.formRules.pushToMSL,
        "required",
        this.isSelectSEUncertified
      );
      if (this.isSelectSEUncertified) {
        this.$refs.form.validateField("pushToMSL");
      } else {
        this.$refs.pushToMSL.clearValidate();
      }
    },
    onFileUpload(files) {
      this.uploadFiles = this.uploadFiles.concat(files);
    },
    deleteFile(i) {
      this.uploadFiles.splice(i, 1);
    },
    getFiles() {
      return this.uploadFiles.map((file) => {
        delete file.url;
        return file;
      });
    },
    onPreview() {
      let valid = true;
      this.$refs.form.validateField(
        ["title", "businessPurposeId", "inquiry", "paperContent"],
        (result) => {
          if (valid) {
            valid = result.length === 0;
          }
        }
      );
      if (valid) {
        let seParams = { seId: this.form.seIds[0] };
        if (this.isBatchPush) {
          seParams = { seId: this.seIds };
        }
        this.previewing = true;
        this.axios
          .post("/quickPush/preview", {
            ...this.form,
            ...seParams,
            batchId: this.data.BatchID,
            files: this.getFiles(),
            greeting: this.form.greeting.trim(),
            title: this.form.title.trim(),
            inquiry: this.form.inquiry.trim(),
          })
          .then(({ code, data }) => {
            if (code == 200) {
              this.previewUrl = data.url;
              this.qrcodeDialogVisible = true;
            } else {
              this.$message.error("Get preview qrcode failed");
            }
            this.previewing = false;
          })
          .catch(() => {
            this.previewing = false;
          });
      }
    },
    selectedSEValidate() {
      return (
        this.form.seIds.length > 1 &&
        this.form.seIds.some((seId) => {
          return this.seList.some((se) => se.SEID === seId && !se.Certified);
        })
      );
    },
    formValidate() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (!valid) {
            return;
          }
          if (this.selectedSEValidate()) {
            this.$message.error(
              "Selected HCP is currently invalid or has been transferred, please cancel your selected."
            );
            return;
          }
          if (!this.isSelectSEUncertified) {
            resolve();
            return;
          }
          this.$alert(
            `The selected HCP is uncertified, please forward to the target HCP.`,
            {
              type: "warning",
              confirmButtonText: "OK",
              callback: () => {
                resolve();
              },
            }
          );
        });
      });
    },
    goToSubmit(status){
      this.actionDisabled = true;
          let seParams = { seId: this.form.seIds[0] };
          if (this.isBatchPush) {
            seParams = { seId: this.seIds };
          }
          const data = {
            pushContentID: this.data.MessageHeadID,
            status,
            ...this.form,
            ...seParams,
            batchId: this.data.BatchID,
            files: this.getFiles(),
            greeting: this.form.greeting.trim(),
            title: this.form.title.trim(),
            inquiry: this.form.inquiry.trim(),
            vvNumber: this.form.vvNumber.trim(),
          };
          const url = this.isBatchPush
            ? "/quickPush/updateBatchDraft"
            : "/quickPush/update";
          this.axios
            .post(url, data)
            .then(({ code, msg, data }) => {
              if (200 === code) {
                this.$emit("success");
                this.$message.success(
                  status === 1 && data ? data : "Save draft successfully"
                );
                this.dialogVisible = false;
              } else if (code === 201) {
                this.dialogVisible = false;
                this.$message.error(msg);
              } else {
                this.$message.error(msg);
                this.actionDisabled = false;
              }
            })
            .catch(() => {
              this.actionDisabled = false;
            });
    },
    alertSubmit(status){
      this.$confirm('请确认推送给HCP。', '', {
              confirmButtonText: 'Submit',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              this.goToSubmit(status);
            }).catch(() => {
              return false;
            });
    },
    onSubmit(status) {
      this.formValidate().then(() => {
        let isMslBusinessPurpose =  this.businessPurposeList.find(item => item.Id ==this.form.businessPurposeId).PurposeType==3;
        if(status == 0) {
          this.goToSubmit(status);
          return;
        }
        if(isMslBusinessPurpose){
          this.$confirm('请确认MSL发起的活动符合合理的业务目的。', '', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }).then(() => {
            this.alertSubmit(status);
          }).catch(() => {
            return false;
          });
        }else{
          this.alertSubmit(status);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__body {
    padding: 0;
    display: flex;
    max-height: 70vh;
  }

  .el-scrollbar.dialog {
    min-width: auto;
  }
}

.el-form-item {
  margin-bottom: 15px !important;

  .el-select,
  .el-input,
  .el-textarea {
    width: 90%;
  }

  .bind-wechat-link {
    text-decoration: underline;
    margin-left: 10px;
    color: $theme-color !important;
  }

  .push-to-msl-msg {
    position: absolute;
    left: 0px;
    top: 90%;
    color: #f56c6c;
    font-size: 12px;
    line-height: 12px;
  }

  .se-control {
    width: 90%;
    display: flex;

    .el-select {
      flex: 1;
    }

    .el-select+.el-button {
      margin-left: 10px;
    }
  }

  .upload-files {
    margin-top: 5px;

    .upload-file-item {
      position: relative;
      display: inline-flex;
      align-items: center;

      a {
        margin-right: 30px;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 300px;
        overflow: hidden;
      }

      span {
        position: absolute;
        right: 0;
        top: 3px;
        cursor: pointer;
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        color: $theme-color;
        display: none;

        &:hover {
          color: #606266;
        }
      }

      &:hover span {
        display: block;
      }
    }
  }

  .security-level,
  .right-find {
    margin-top: 5px;
    width: 90%;
    color: #e6a23c;
    line-height: 20px;
    font-size: 12px;
    word-break: break-word;

    &,
    i {
      font-weight: bold;
    }

    i {
      margin-right: 3px;
    }

    a {
      text-decoration: underline;
    }
  }
}

.footer {
  text-align: center;
}
</style>
